module.exports = __webpack_public_path__ + "img/shouye2.eab00ec8.png";